<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/myeduclass.png">
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "MyEduClass",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('MyEduClass SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/myeduclass/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/myeduclass/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goMyEduClass()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/myeduclass/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/myeduclass/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.goMyEduClass()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goMyEduClass() {
      let newUserData = {
        school_id: this.userData.school_id,
        campus_id: this.userData.campus_id,
        campus_name: this.userData.campus_name,
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        username: this.userData.username,
        roleType: this.userData.role_type,
      };

      if (this.userData.role_type === "student") {
        newUserData.class = this.userData.class[0].grade;
        newUserData.branch = this.userData.class[0].branch;
      } else if (this.userData.role_type === "teacher") {
        newUserData.classes = this.userData.class
          .map(item => `${item.grade}-${item.branch}`)
          .join(",");
      }

      const textJson = JSON.stringify(newUserData);
      const uriText = decodeURIComponent(textJson)
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.secretKey).toString();

      location.href = "https://lms.myeduclass.com/#/?sso=" + btoa(ciphertext);
    },
  }
}
</script>
